import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5at7my5x5: FaireProductEntity = {
  token: "p_g5at7my5x5",
  type: "product",
  name: '(KG) FREE SHAPE - CHALCEDONY, BLUE ONE SIDE POLISHED 1-3"',
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/eaf7898e7172af920a710a70a3b178dc4fe5cfe764552fe9a94dfb8d11ff848d.jpeg",
  galleryImageUrls: [],
  priceDollars: 45.31,
  description: '(KG) FREE SHAPE - CHALCEDONY, BLUE ONE SIDE POLISHED 1-3"',
  tags: [],
  msrpDollars: 90.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:40.596Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
